export class customEventsNames{
    constructor() {
        this.openModal = 'openModal';
        this.closeModal = 'closeModal';
        this.playVideoInModal = 'playVideoInModal';
        this.playYoutubeVideoInModal = 'playYoutubeVideoInModal';
        this.videoPlayingInModal = 'videoStartedPlayingInModal';
        this.expandedCollapsedText = 'expandedCollapsedText';
        this.collapsedCollapsedText = 'collapsedCollapsedText'; 

        this.accordionInitialised = 'accordionInitialized';
        this.accordionActivateItemEventName = 'activateAccordionItem';
        this.accordionDeactivateItemEventName = 'deactivateAccordionItem';
        this.accordionDeactivateAllItemsEventName = 'deactivateAllAccordionItems';
    }
};
export default new customEventsNames();